

export const index = 11;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/user-guide/terminal-persistence/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/11.DCDl4y74.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/IHki7fMi.js"];
export const stylesheets = [];
export const fonts = [];
